<div class="link-pages-section">
  <!-- Footer Header - Only shown when opened in new tab -->
  <app-footer-header *ngIf="isStandalonePage"></app-footer-header>
  
  <!-- Hero Section -->
  <div class="hero-section">
    <div class="hero-content">
      <div class="hero-text">
        <h1 class="hero-title">
          <span class="title-line">Legal <span class="highlight">Documents</span></span>
        </h1>
        <p class="hero-subtitle">Preview and access our important policies and statements</p>
      </div>
    </div>
  </div>

  <!-- Documents Grid -->
  <div class="documents-section">
    <div class="documents-container">
      <div class="documents-grid">
        <div 
          *ngFor="let document of pdfDocuments; let i = index" 
          class="document-card"
          [id]="document.id"
          [style.animation-delay]="(i * 0.2) + 's'"
        >
          <!-- Card Header -->
          <div class="card-header">
            <div class="card-icon" [style.background]="document.color">
              <span class="icon-text">{{ document.icon }}</span>
            </div>
            <div class="card-title-section">
              <h3 class="card-title">{{ document.title }}</h3>
              <p class="card-description">{{ document.description }}</p>
            </div>
          </div>
          
          <!-- PDF Preview Container -->
          <div class="pdf-preview-container">
            <div class="pdf-overlay" (mouseenter)="startScroll(document.id)" (mouseleave)="stopScroll(document.id)">
              <div class="scroll-indicator">
                <span>Preview</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M7 13L12 8L17 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
                         <div 
               [id]="'pdf-container-' + document.id"
               class="pdf-container"
             >
               <!-- PDFs will be loaded dynamically -->
             </div>
          </div>
          
          <!-- Action Button -->
          <div class="card-action">
            <button class="preview-button" (click)="openPdf(document)">
              <span class="button-text">Open Full PDF</span>
              <svg class="button-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          
          <!-- Hover Effects -->
          <div class="card-glow" [style.background]="document.color + '30'"></div>
          <div class="card-border" [style.border-color]="document.color"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Floating Elements -->
  <div class="floating-elements">
    <div class="floating-circle circle-1"></div>
    <div class="floating-circle circle-2"></div>
    <div class="floating-circle circle-3"></div>
  </div>

  <app-footer *ngIf="isStandalonePage"></app-footer>
  
</div>
